<div class="img-container" [class]="inputClass">
  <img [ngClass]="'border-radius-' + borderRadius"
       [src]="base64 ?? src ?? '/assets/img/placeholders/' + placeholder + '.png'"
       [height]="height || size"
       [style.objectFit]="objectFit"
       [width]="width || size" />
</div>
